<template>
  <div class="tree-item">
    <div class="item-row">
      <div class="expand-collapse-container">
        <button
          v-if="props.item.children?.length"
          class="expand-collapse-btn"
          @click="emit('toggleExpanded', props.item.id)"
        >
          <PsIcon
            name="tree-arrow"
            :size="11"
            :class="isExpanded ? 'expanded' : ''"
          />
        </button>
      </div>
      <div class="item-content">
        <slot
          name="item"
          :item="props.item"
        >
          {{ props.item.name }}
        </slot>
      </div>
    </div>
    <div
      v-if="props.item.children && props.item.children && isExpanded"
      class="children"
    >
      <TreeItem
        v-for="childItem in props.item.children"
        :key="childItem.id"
        :item="childItem"
        :expanded="props.expanded"
        @toggleExpanded="emit('toggleExpanded', $event)"
      >
        <template #item="{ item: innerItem }">
          <slot
            name="item"
            :item="innerItem"
          />
        </template>
      </TreeItem>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PsIcon from '@/ContextTab/components/UI/PsIcon.vue'
import type { ITreeItem } from './search'


const props = defineProps<{
  item: ITreeItem
  expanded: ITreeItem['id'][]
}>()

const emit = defineEmits<{
  (e: 'toggleExpanded', id: ITreeItem['id']): void
}>()

const isExpanded = computed(() => props.expanded.includes(props.item.id))

</script>

<style scoped>
.tree-item {

  .item-row {
    display: flex;

    .expand-collapse-container {
      flex: 0 0 30px;
      text-align: center;

      .expand-collapse-btn {
        width: 25px;
        height: 25px;
        border: none;
        background: none;

        .expanded {
          transform: rotate(90deg);
        }
      }
    }

    .item-content {
      display: flex;
      justify-content: flex-start;
      align-content: center;
    }
  }

  .children {
    padding-left: 16px; /* TODO: replace */
  }
}
</style>
